import * as React from "react";
import HorizontalTagsListView from "./HorizontalTagsListView";
import TypeAhead, { TypeAheadResults, TypeAheadElement } from "./TypeAhead";

export interface HorizontalTagsListViewTypeAheadProps {
    tagsStringArray: string[];
    onTagRemove: (index: number) => void;
    name: string;
    value: string;
    placeholder: string;
    onTypeAheadChange: (input: string) => Promise<TypeAheadResults>;
    onTypeAheadSelect: (input: TypeAheadElement) => void
}

const HorizontalTagsListViewTypeAhead: React.StatelessComponent<HorizontalTagsListViewTypeAheadProps> = (props: HorizontalTagsListViewTypeAheadProps) => {
    return (
        <div className="food-dislikes-container">
            <HorizontalTagsListView tagsStringArray={props.tagsStringArray} onTagRemove={props.onTagRemove} />
            <TypeAhead widgetName={props.name} name={props.name} value={props.value} placeholder={props.placeholder} onTypeAheadChange={props.onTypeAheadChange} onTypeAheadSelect={props.onTypeAheadSelect}/>
        </div>
    );
};

export default HorizontalTagsListViewTypeAhead;
